import { PSCType } from "@/graphql";
import type { ActionButtonType } from "./ActionButton";
import PSCCreate from "@/modules/psc/views/PSCCreate.vue";

const CreateA3Button: ActionButtonType = {
  label: "components.eventAction.event.actionButtons.CreateA3Button.text",

  disabled: false,
  modalComponent: PSCCreate,
  modalComponentAdditionalBind: {
    showInModal: true,
    type: PSCType.A3,
  },
};

export default CreateA3Button;
